import { Link } from 'react-router-dom'
import { LegalPageLayout } from './LegalPageLayout'

// Contenu déplacé depuis l'ancienne LegalModal (source unique, plus de modale).
export default function MentionsLegales() {
  return (
    <LegalPageLayout title="Mentions légales">
      <p className="italic text-sm">En vigueur au 17/04/2026</p>

      <p>
        Conformément aux dispositions de la loi n°2004-575 du 21 juin 2004 pour la Confiance en l'économie numérique, il est porté à la connaissance des utilisateurs et visiteurs, ci-après l'« Utilisateur », du site <a href="https://www.lorenzcampan-ia.fr" className="text-accent hover:underline">https://www.lorenzcampan-ia.fr</a>, ci-après le « Site », les présentes mentions légales.
      </p>

      <p>
        La connexion et la navigation sur le Site par l'Utilisateur implique acceptation intégrale et sans réserve des présentes mentions légales.
      </p>

      <p>
        Ces dernières sont accessibles sur le Site à la rubrique « Mentions légales ».
      </p>

      <h2 className="text-xl font-semibold text-white mt-8 mb-4">Éditeur du site</h2>

      <p>Le Site est édité par :</p>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Lorenz Campan</strong>, entrepreneur individuel</li>
        <li><strong>SIRET :</strong> 990 305 492 00011</li>
        <li><strong>Adresse :</strong> 14 route du chêne vert 16600 Mornac</li>
        <li><strong>Email :</strong> contact@lorenzcampan-ia.fr</li>
        <li><strong>Directeur de la publication :</strong> Lorenz Campan</li>
      </ul>

      <p className="text-sm border-l-2 border-white/20 pl-4 py-1 text-white/50 italic mt-4">
        Note : conformément à la LCEN, un numéro de téléphone est en principe requis. En tant qu'entrepreneur individuel, l'indication d'une adresse email comme unique moyen de contact est largement tolérée en pratique, mais expose techniquement à un risque de non-conformité minime.
      </p>

      <h2 className="text-xl font-semibold text-white mt-8 mb-4">Hébergeur</h2>

      <p>Le Site est hébergé par :</p>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Vercel Inc.</strong></li>
        <li>340 S Lemon Ave #4133, Walnut, CA 91789, États-Unis</li>
        <li><strong>Site web :</strong> <a href="https://vercel.com" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">https://vercel.com</a></li>
      </ul>

      <h2 className="text-xl font-semibold text-white mt-8 mb-4">Accès au site</h2>

      <p>
        Le Site est normalement accessible à tout moment à l'Utilisateur. Toutefois, l'éditeur pourra, à tout moment, suspendre, limiter ou interrompre le Site afin de procéder notamment à des mises à jour ou des modifications de son contenu. L'éditeur ne pourra en aucun cas être tenu responsable des conséquences éventuelles de cette indisponibilité sur les activités de l'Utilisateur.
      </p>

      <h2 className="text-xl font-semibold text-white mt-8 mb-4">Collecte des données personnelles</h2>

      <p>
        Le Site assure à l'Utilisateur une collecte et un traitement des données personnelles dans le respect de la vie privée, conformément à la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés, et au Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 (RGPD).
      </p>

      <p>
        En vertu de la réglementation applicable, l'Utilisateur dispose d'un droit d'accès, de rectification, de suppression et d'opposition de ses données personnelles. Ces droits peuvent être exercés :
      </p>

      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Par email :</strong> contact@lorenzcampan-ia.fr</li>
        <li><strong>Via le formulaire de contact</strong> disponible sur le Site</li>
      </ul>

      <p>
        Pour plus d'informations, consulter la <Link to="/politique-de-confidentialite" className="text-accent hover:underline">Politique de confidentialité</Link> du Site.
      </p>

      <h2 className="text-xl font-semibold text-white mt-8 mb-4">Propriété intellectuelle</h2>

      <p>
        Toute utilisation, reproduction, diffusion, commercialisation ou modification de tout ou partie du Site, sans autorisation expresse de l'éditeur, est prohibée et pourra entraîner des actions et poursuites judiciaires telles que prévues par la réglementation en vigueur.
      </p>

      <h2 className="text-xl font-semibold text-white mt-8 mb-4">Droit applicable et juridiction compétente</h2>

      <p>
        Les présentes mentions légales sont soumises au droit français. En cas de litige, et à défaut de résolution amiable, les tribunaux d'Angoulême seront compétents.
      </p>
    </LegalPageLayout>
  )
}
